import React from 'react';
import { Badge } from 'react-bootstrap';
import { AlertTriangle, Building, Calendar, Tag } from 'lucide-react';
import { IssueWithBuilding } from '../../../types/issues';
import { issuePriorityColors, issuePriorityLabels } from '../../../types/issuePriorityDisplay';
import { issueComponentCategoryText } from '../../../Helpers/issueUtils';
import SourceWorkOrderBadge from './SourceWorkOrderBadge';
import IssueAssessmentBadge from './IssueAssessmentBadge';

interface IssueCardProps {
    issue: IssueWithBuilding;
    onClick?: () => void;
    isSelected?: boolean;
}

/**
 * Card displaying an issue item for the management dashboard
 * Click to open detail modal
 */
const IssueCard: React.FC<IssueCardProps> = ({ issue, onClick, isSelected }) => {
    const formatDate = (dateStr: string) => {
        // Parse YYYY-MM-DD hh:mm:ss format
        const parts = dateStr.split(' ')[0];
        return new Date(parts).toLocaleDateString('sv-SE');
    };

    const truncateDescription = (description: string, maxLength: number = 60) => {
        if (description.length <= maxLength) return description;
        return description.substring(0, maxLength) + '...';
    };

    return (
        <div
            className={`management-item${isSelected ? ' management-item--selected' : ''}`}
            onClick={onClick}
            role={onClick ? 'button' : undefined}
            tabIndex={onClick ? 0 : undefined}
            onKeyDown={onClick ? (e) => e.key === 'Enter' && onClick() : undefined}
        >
            <div className="d-flex justify-content-between align-items-start">
                <div className="flex-grow-1 me-2">
                    <div className="d-flex align-items-center gap-1 mb-1">
                        <Badge bg="" className="badge-felanmalan d-inline-flex align-items-center gap-1">
                            <AlertTriangle size={10} />
                            Felanmälan
                        </Badge>
                    </div>
                    <div className="fw-medium">{truncateDescription(issue.description)}</div>
                    <div className="small text-muted d-flex align-items-center gap-1"><Building size={12} />{issue.buildingName}</div>
                    {issue.componentCategory && (
                        <div className="small text-muted d-flex align-items-center gap-1"><Tag size={12} />{issueComponentCategoryText(issue.componentCategory)}</div>
                    )}
                    {issue.source === 'workOrder' && issue.sourceWorkOrderKey && (
                        <div><SourceWorkOrderBadge workOrderKey={issue.sourceWorkOrderKey} /></div>
                    )}
                    <IssueAssessmentBadge issue={issue} className="mt-1" />
                </div>
                <Badge bg={issuePriorityColors[issue.priority]} className="priority-badge">
                    {issuePriorityLabels[issue.priority]}
                </Badge>
            </div>
            <div className="mt-2">
                <small className="text-muted d-flex align-items-center gap-1"><Calendar size={12} />Skapad: {formatDate(issue.createdAt)}</small>
            </div>
        </div>
    );
};

export default IssueCard;
